import React, { useContext, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { Container } from "./styles";
import Icon from "../Icon";
import { SearchContext } from "../../context";
import { useMediaQuery } from "react-responsive";

const Aggregate = ({ history, location, name, type, aggregate, className }) => {
  // Media Query for Mobile version
  const isDesktopOrLaptop = useMediaQuery({ minWidth: 800 });
  const { selectedTrackList, exitEntityToBrowse, removeAggregate } = useContext(
    SearchContext
  );

  useEffect(() => {
    if (type !== "aggregate" && !selectedTrackList) {
      history.push("/browse");
    }
  }, [type, selectedTrackList, history]);

  return (
    <>
      <Container
        isAggregate={
          location.pathname === "/browse" || location.pathname === "/"
        }
        isMobile={!isDesktopOrLaptop}
        onClick={() => {
          if (type === "aggregate") return removeAggregate(aggregate);
          exitEntityToBrowse();
          history.push("/browse");
        }}
        className={className}
      >
        {type === "aggregate" ? (
          <Icon type="quick_filter" size="xs" color="currentColor" />
        ) : (
          <img
            style={{ height: 14, width: 14 }}
            src={require(`../../assets/${selectedTrackList.type.toLowerCase()}.svg`)}
            alt="icon"
          />
        )}
        <div>
          <p className="agr-name ws-nowrap">
            {type === "aggregate" ? name : selectedTrackList.name}
          </p>
        </div>
        {type !== "aggregate" && (
          <img
            className="clear"
            style={{ height: 10, width: 10 }}
            src={require("../../assets/Clear.svg")}
            alt={"icon"}
          />
        )}
      </Container>
    </>
  );
};

export default withRouter(Aggregate);
